// export const API_URL = "http://tamra-back.test/api";
export const API_URL = "https://qyadatstore.com/backend/api";
